export default __webpack_public_path__ + "static/media/avatar5.5237419b.png";